import * as questionAction from 'src/store/actions';

const initialState = {
  loading: false,
  order: {},
  questionsData: {},
  matchRulesResult: null,
  error: null,
  printHtml: {
    head: '',
    parts: {}
  },
  businessCaseResult: null
};

/**
 *TODO
 */
const questionReducer = (state = initialState, action) => {
  switch (action.type) {
    case questionAction.SET_QUESTIONS_DATA:
      return {
        ...state,
        questionsData: {
          ...state.questionsData,
          ...action.payload
        }
      };
    case questionAction.SET_MATCH_RULES_RESULT:
      return {
        ...state,
        matchRulesResult: action.payload
      };
    case questionAction.SET_PRINT_HTML_PART:
      return {
        ...state,
        printHtml: {
          ...state.printHtml,
          parts: {
            ...state.printHtml.parts,
            [action.payload.page]: action.payload.html
          }
        }
      };
    case questionAction.SET_PRINT_HTML_HEAD:
      return {
        ...state,
        printHtml: {
          ...state.printHtml,
          head: state.printHtml.head + action.payload
        }
      };
    case questionAction.CLEAR_PRINT_HTML:
      return {
        ...state,
        printHtml: { head: '', parts: {} }
      };
    case questionAction.SEND_BUSINESS_CASE_RESULT:
      return {
        ...state,
        businessCaseResult: action.payload
      };
    default: {
      return state;
    }
  }
};

export default questionReducer;
